module.exports = __webpack_public_path__ + "img/Wolt_600x150.276ea193.jpg";